import React from 'react';
import FlightSchedule from './FlightSchedule';
import http from 'utils/http';
import events from 'utils/evemts';
import cookies from 'utils/cookies';
import { connect } from 'react-redux';
import { setDeleteAction } from 'store/actions/deleteAction';
import { getLocatDate } from 'utils/converter';
import moment from 'moment';

const getDefaultScheduleFields = () => ({
  airline: '',
  flight_no: '',
  org: '',
  dest: '',
  org_stn: false,
  dest_stn: false,
  platform: '',
  ac_type: '',
  std: '',
  sta: '',
  from: '',
  to: '',
  sta_next: false,
  sta_next2: false,
  mon: false,
  tue: false,
  wed: false,
  thu: false,
  fri: false,
  sat: false,
  sun: false
});

class FlightScheduleContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scheduleList: [],
      tab: 'active',
      date: getLocatDate(),
      locationModal: false,
      scheduleFields: [getDefaultScheduleFields()],
      scheduleErrors: [{}],
      openAddSchedule: false,
      flightSettings: {
        mandatory_number: false,
        limit_input: false
      },
      filterData: [],
      filter: {},
      airlines: [],
      airlineList: [],
      locationList: [],
      scheduleOrgDest: [{
        org: null,
        dest: null
      }],
      stationList: [],
      selectedFlight: [],
      conflictModal: false,
      conflictIndex: -1,
      conflictList: []
    };
    this.eventSource = null;
  }

  normalizeScheduleFields = (scheduleFields) => {
    const source = scheduleFields && typeof scheduleFields === 'object' ? scheduleFields : {};
    return {
      ...getDefaultScheduleFields(),
      ...source,
      sta_next: !!source.sta_next,
      sta_next2: !!source.sta_next2,
      mon: !!source.mon,
      tue: !!source.tue,
      wed: !!source.wed,
      thu: !!source.thu,
      fri: !!source.fri,
      sat: !!source.sat,
      sun: !!source.sun
    };
  };

  componentDidMount() {
    this.fetchLocations();
    this.fetchAirlines();
    this.getConfigValues();
    http.get('/station').then(({ data }) => {
      this.setState({ stationList: data.data });
    });
    this.eventSource = events('admin', 'flight_schedule');
    this.eventSource.onmessage = (event) => {
      const msg = JSON.parse(event.data || '{}');
      if (msg.data && ((msg.data.org == cookies.get('station_code') && msg.data.org_stn) || (msg.data.dest == cookies.get('station_code') && msg.data.dest_stn))) {
        if (
          (this.state.tab === 'active' &&
            moment(this.state.date).isBetween(
              moment(msg.data.from, 'YYYY-MM-DD'),
              moment(msg.data.to, 'YYYY-MM-DD'),
              null,
              '[]'
            )) ||
          (this.state.tab === 'expired' &&
            moment(this.state.date).isAfter(moment(msg.data.to, 'YYYY-MM-DD')))
        ) {
          if (msg.action == 'ADD') {
            this.setState({ scheduleList: [...this.state.scheduleList, msg.data] }, () => { this.filterData(); });
          }
          if (msg.action == 'UPDATE') {
            const scheduleList = [...this.state.scheduleList];
            const index = scheduleList.findIndex(c => msg.data && c.id == msg.data.id);
            if (index > -1) {
              scheduleList[index] = { ...msg.data };
              this.setState({ scheduleList }, () => { this.filterData(); });
            }
          }
        }
      }
      if (msg.data && msg.action && msg.action == 'DELETE') {
        const scheduleList = [...this.state.scheduleList];
        const index = scheduleList.findIndex(c => msg.data && c.id == msg.data.id);
        if (index > -1) {
          scheduleList.splice(index, 1);
          this.setState({ scheduleList }, () => { this.filterData(); });
        }
      }
    };
  }

  componentWillUnmount() {
    this.eventSource.close();
  }

  fetchSchedules = () => {
    http.get(`/flight_schedule?date=${this.state.date}&tab=${this.state.tab}&station=${cookies.get('station_code')}`)
      .then((response) => {
        this.setState({ scheduleList: response?.data?.data || [] }, () => { this.filterData(); });
      });
  };

  fetchConflicts = () => {
    http.get(`/flight_schedule/conflicts?station=${cookies.get('station_code')}`)
      .then((response) => {
        this.handleClose('add');
        this.setState({
          conflictList: response?.data?.data || [],
          conflictModal: true 
        });
      });
  };

  filterData = () => {
    const { scheduleList, filter } = this.state;
    let data = [...scheduleList];
    data = data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    let airlines = scheduleList.map((a) => a.airline);
    airlines = airlines.filter((item) => this.state.airlineList.map((al) => al.code).includes(item));
    airlines = airlines.filter((item, index, self) => self.indexOf(item) === index);
    if (filter.airline && filter.airline != '') {
      data = data.filter((a) => a.airline == filter.airline && this.state.airlineList.map((al) => al.code).includes(a.airline));
    }else {
      data = data.filter((a) => this.state.airlineList.map((al) => al.code).includes(a.airline));
    }
    if (this.state.filter.search) {
      const search = this.state.filter.search.toLowerCase();
      data = data.filter((item) => {
        return (
          item.airline?.toLowerCase().includes(search) ||
          item.flight_no?.toLowerCase().includes(search) ||
          (item.airline + item.flight_no)?.toLowerCase().includes(search) ||
          item.org?.toLowerCase().includes(search) ||
          item.dest?.toLowerCase().includes(search) ||
          item.ac_type?.toLowerCase().includes(search)
        );
      });
    }
    this.setState({
      filterData: data,
      airlines: airlines
    });
  };

  onChangeFilter = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        [e.target.name]: e.target.value
      }
    }, () => this.filterData());
  };


  handleClose = (type) => {
    switch (type) {
      case 'add':
        this.setState({
          openAddSchedule: false,
          scheduleFields: [getDefaultScheduleFields()],
          scheduleErrors: [{}],
          scheduleOrgDest: [{
            org: null,
            dest: null
          }],
        });
        break;
      default:
        break;
    }
  };

  fetchLocations = () => {
    http.get('/locations')
      .then((response) => {
        const locationList = response.data.data.filter((item, index, self) =>
          self.findIndex((t) => t.iata_code === item.iata_code) === index
        );
        this.setState({ locationList: locationList });
      });
  };

  fetchAirlines = () => {
    http.get(`/airline?active=${true}`)
      .then((response) => {
        this.setState({ airlineList: response.data.data }, () => {
          this.fetchSchedules();
        });
      });
  };

  isStationCode = (code) => this.state.stationList.some(c => c.code === code);

  onChange = (e, newvalue = null, index) => {
    const { name, id, value: targetValue } = e.target;
    const fieldName = name || id.split('-')[0];
    const value = newvalue?.iata_code || targetValue;
    const stn_code = cookies.get('station_code');
    let otherFields = {};
    if (fieldName === 'org' || fieldName === 'dest') {
      const { org, dest } = this.state.scheduleFields[index];
      let orgval = '';
      let destval = '';

      if (value === stn_code) {
        if (fieldName === 'org') {
          orgval = stn_code;
          otherFields = { org_stn: true };
          destval = dest === stn_code ? '' : dest;
        } else if (fieldName === 'dest') {
          orgval = org === stn_code ? '' : org;
          otherFields = { dest_stn: true };
          destval = stn_code;
        }
      } else {
        orgval = fieldName === 'org' ? value : stn_code;
        destval = fieldName === 'dest' ? value : stn_code;
        otherFields = {
          org_stn: fieldName === 'org' ? false : true,
          dest_stn: fieldName === 'dest' ? false : true 
        };
      }
      if (orgval) {
        otherFields.org_stn = this.isStationCode(orgval);
      }

      if (destval) {
        otherFields.dest_stn = this.isStationCode(destval);
      }

      const getLocation = (iata_code) => this.state.locationList.find(c => c.iata_code === iata_code);

      this.setState({
        scheduleOrgDest: this.state.scheduleOrgDest.map((field, i) => i === index ? {
          org: getLocation(orgval),
          dest: getLocation(destval)
        } : field),
        scheduleFields: this.state.scheduleFields.map((field, i) => i === index ? {
          ...field,
          ...otherFields,
          org: orgval,
          dest: destval
        } : field)
      });
    } else {
      this.setState({
        scheduleFields: this.state.scheduleFields.map((field, i) => i === index ? {
          ...field,
          [fieldName]: value
        } : field)
      });
    }
  };

  changeDateAndTime = (element, type, index = 0) => {
    let fields = {};
    if (type == 'from') {
      if (this.state.scheduleFields[index].to && element.format('YYYY-MM-DD') > this.state.scheduleFields[index].to) {
        fields = { to: element.format('YYYY-MM-DD'), };
      }
    }
    this.setState({
      scheduleFields: this.state.scheduleFields.map((field, i) => i === index ? {
        ...field,
        [type]: (type == 'sta' || type == 'std') ? element.target.value : element.format('YYYY-MM-DD'),
        ...fields
      } : field)
    });
  };

  changeCheck = (e, index) => {
    const { name, checked } = e.target;
    let others = {};

    if (name === 'all') {
      others = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']
        .reduce((acc, day) => ({
          ...acc,
          [day]: checked 
        }), {});
    }

    this.setState((prevState) => ({
      scheduleFields: prevState.scheduleFields.map((field, i) => i === index ? {
        ...field,
        ...others,
        [name]: checked
      } : field)
    }));
  };

  updateSchedule = async (id, formdata) => {
    await http.put('/flight_schedule/' + id, formdata)
      .then(({ data }) => {
        if (data.status == 'success') {
          if (!formdata.conflictId) {
            this.setState({
              scheduleFields: [getDefaultScheduleFields()],
              scheduleOrgDest: [{
                org: null,
                dest: null
              }],
              openAddSchedule: false
            });
          } else {
            this.applyConflictResolution(formdata, data);
          }
        }
      });
  };

  applyConflictResolution = (formdata, data) => {
    const index = this.state.conflictList.findIndex(conflict => conflict.id === formdata.conflictId);
    if (index === -1) return;
    const cdata = formdata.existing ?
      {
        existing: {
          ...data.data,
          updated: true 
        } 
      } :
      {
        incoming: {
          ...data.data,
          updated: true 
        } 
      };
    const conflicts = [...this.state.conflictList];
    conflicts[index] = {
      ...conflicts[index],
      ...cdata
    };
    this.setState({ conflictList: conflicts }, () => this.handleConflict(conflicts[index], index));
  };

  deleteSchedule = async (row, data={}) => {
    await http.put('/flight_schedule/delete_update/' + row.id, data).then(({ data }) => {
      if (data.status == 'success') {
        this.props.setDelete({
          modal: false,
          id: false,
          anchorEl: false,
          onConfirm: () => { },
        });
      }
    });
  };

  handleDelete = (row, anchorEl) => {
    let data ={};
    if(row.org === cookies.get('station_code')){
      data = { org_stn: false };
    } else if(row.dest === cookies.get('station_code')){
      data = { dest_stn: false };
    }
    this.props.setDelete({
      modal: true,
      id: row.id,
      anchorEl,
      onConfirm: () => this.deleteSchedule(row),
      deleteType: row.org_stn && row.dest_stn ? 'stn': null,
      onConfirmStn: () => this.deleteSchedule(row, data),
    });
  };


  getConfigValues = async () => {
    http.get('/settings?key=flight_schedule')
      .then((response) => {
        // handle success
        if (response.data.data) {
          this.setState({ flightSettings: response.data.data.value });
        }
      });
  };

  changeSettings = (e) => {
    const name = e.target.name;
    this.setState({
      flightSettings: {
        ...this.state.flightSettings,
        [name]: !this.state.flightSettings[name]
      }
    }, () => this.setSettingsValues(this.state.flightSettings));
  };

  setSettingsValues = async (formData) => {
    await http.put('/settings?key=flight_schedule', formData);
  };

  addEditSchedule = async (e, index) => {
    e.preventDefault();
    let formdata = { ...this.state.scheduleFields[index] };
    if (this.validation(index)) {
      if (formdata.id) {
        this.updateSchedule(formdata.id, formdata);
      } else {
        await http.post('/flight_schedule', formdata)
          .then(({ data }) => {
            if (data.status == 'success') {
              if (!formdata.conflictId) {
                this.setState({
                  scheduleFields: [getDefaultScheduleFields()],
                  scheduleOrgDest: [{
                    org: null,
                    dest: null
                  }],
                  openAddSchedule: false
                });
              } else {
                this.applyConflictResolution(formdata, data);
              }
            }
          });
      }
    }
  };

  handleUpload = (e) => {
    //take csv file and upload
    e.preventDefault();
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('station', JSON.stringify(this.state.stationList.map(station => station.code)));
    http.post('/flight_schedules', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(({ data }) => {
      this.fetchSchedules();
      this.setState({ locationModal: false });
      const conflicts = data?.data?.conflicts;
      if (conflicts) {
        this.fetchConflicts();
      }
    });
  };

  requiredScheduleFields = ['airline', 'flight_no', 'org', 'dest', 'platform', 'ac_type', 'std', 'sta', 'from', 'to'];

  validation = (index) => {
    const scheduleFields = { ...this.state.scheduleFields[index] };
    const error = {};
    this.requiredScheduleFields.forEach((field) => {
      if (!scheduleFields[field] || scheduleFields[field].trim().length === 0) {
        error[field] = true;
      }
    });
    const formValid = Object.keys(error).length === 0;
    this.setState((prevState) => {
      const scheduleErrors = [...prevState.scheduleErrors];
      scheduleErrors[index] = error;
      return { scheduleErrors };
    });
    return formValid;
  };

  handleOpen = (type, scheduleFields) => {
    switch (type) {
      case 'add':
        this.setState({
          openAddSchedule: true,
          scheduleFields: [getDefaultScheduleFields()],
          scheduleOrgDest: [{
            org: null,
            dest: null
          }],
        });
        break;
      case 'edit': {
        const normalizedScheduleFields = this.normalizeScheduleFields(scheduleFields);
        this.setState({
          openAddSchedule: true,
          scheduleFields: [normalizedScheduleFields],
          scheduleOrgDest: [{
            org: this.state.locationList.find(c => c.iata_code === normalizedScheduleFields.org) || null,
            dest: this.state.locationList.find(c => c.iata_code === normalizedScheduleFields.dest) || null
          }],
        });
        break;
      }
      default:
        break;
    }
  };

  handleConflict = (conflict, index) => {
    this.setState({
      openAddSchedule: false,
      conflictIndex: index,
      scheduleFields: [{
        ...this.normalizeScheduleFields(conflict.existing),
        conflictId: conflict.id,
        existing: true 
      }, {
        ...this.normalizeScheduleFields(conflict.incoming),
        conflictId: conflict.id 
      }  ],
      scheduleOrgDest: [{
        org: this.state.locationList.find(c => c.iata_code === conflict.existing.org) || null,
        dest: this.state.locationList.find(c => c.iata_code === conflict.existing.dest) || null
      }, {
        org: this.state.locationList.find(c => c.iata_code === conflict.incoming.org) || null,
        dest: this.state.locationList.find(c => c.iata_code === conflict.incoming.dest) || null
      }],
    });
  };

  closeConflictModal = () => {
    this.setState({
      conflictModal: false,
      conflictIndex: -1,
      conflictList: [],
      openAddSchedule: false,
      scheduleFields: [getDefaultScheduleFields()],
      scheduleOrgDest: [{
        org: null,
        dest: null
      }],
    });
  };

  updateConflicts = (conflict, action) => {
    // Implement the logic to handle conflict updates based on the action ('resolved' or 'delete')
    if(action === 'resolved') {
      http.post('/flight_schedule/resolve_conflict', { id: conflict.id }).then(() => {
        let conflictList = [...this.state.conflictList];
        conflictList.splice(this.state.conflictIndex, 1);
        this.setState({
          conflictList,
          conflictIndex: -1,
        });
      });
    } else if(action === 'delete') {
      http.post('/flight_schedule/delete_conflict', { id: conflict.id }).then(() => {
        this.setState({
          conflictList: this.state.conflictList.filter(c => c.id !== conflict.id),
          conflictIndex: -1,
        });
      });
    }
  };

  setActive = (id, active) => {
    this.updateSchedule(id, { active });
  };

  handleRowClick = (row) => {
    let selectedFlight = [...this.state.selectedFlight];
    let flightIndex = selectedFlight.findIndex(f => f.id === row.id);
    if (flightIndex === -1) {
      this.setState(prevState => ({
        selectedFlight: [
          ...prevState.selectedFlight,
          { ...row }
        ]
      }));
    }
    else {
      selectedFlight.splice(flightIndex, 1);
      this.setState({ selectedFlight });
    }
  };

  deleteBulkSchedule = (rows) => {
    http.post('/bulk_delete', { data: rows }).then(({ data }) => {
      if (data.status == 'success') {
        this.props.setDelete({
          modal: false,
          id: false,
          anchorEl: false,
          onConfirm: () => { },
        });
      }
    });
  };

  handleBulkDelete = (anchorEl) => {
    const { selectedFlight } = this.state;
    let rows = this.state.scheduleList.filter(row => selectedFlight.some(f => f.id === row.id));
    let data = [];
    rows.map(row => {
      if(row.org === cookies.get('station_code')){
        data.push({
          id: row.id,
          org_stn: false 
        });
      } else if(row.dest === cookies.get('station_code')){
        data.push({
          id: row.id,
          dest_stn: false 
        });
      }
    });

    this.props.setDelete({
      modal: true,
      id: rows.map(r => r.id),
      anchorEl,
      onConfirm: () => this.deleteBulkSchedule(rows.map(r => { return { id: r.id }; })),
      deleteType: rows.some(r => r.org_stn || r.dest_stn) ? 'stn' : null,
      onConfirmStn: () => this.deleteBulkSchedule(data),
    });
  };

  onChangeTab = (e) => {
    this.setState({ tab: e.target.value }, () => {
      this.fetchSchedules();
    });
  };


  render() {
    return (
      <>
        <FlightSchedule
          filter={this.state.filter}
          onChangeFilter={this.onChangeFilter}
          tab={this.state.tab}
          onChangeTab={this.onChangeTab}
          airlines={this.state.airlines}
          scheduleList={this.state.filterData}
          handleClose={this.handleClose}
          locationModal={this.state.locationModal}
          handleOpen={this.handleOpen}
          onChange={this.onChange}
          openAddSchedule={this.state.openAddSchedule}
          scheduleFields={this.state.scheduleFields}
          scheduleErrors={this.state.scheduleErrors}
          addSchedule={this.addEditSchedule}
          changeDateTime={this.changeDateAndTime}
          changeCheck={this.changeCheck}
          handleDelete={this.handleDelete}
          changeSettings={this.changeSettings}
          flightSettings={this.state.flightSettings}
          airlineList={this.state.airlineList}
          locationList={this.state.locationList}
          scheduleOrgDest={this.state.scheduleOrgDest}
          filterData={this.filterData}
          handleUpload={this.handleUpload}
          handleRowClick={this.handleRowClick}
          selectedFlight={this.state.selectedFlight}
          handleBulkDelete={this.handleBulkDelete}
          conflictModal={this.state.conflictModal}
          conflictList={this.state.conflictList}
          conflictIndex={this.state.conflictIndex}
          closeConflictModal={this.closeConflictModal}
          handleConflict={this.handleConflict}
          fetchConflicts={this.fetchConflicts}
          updateConflicts={this.updateConflicts}
        />
      </>
    );
  }
}


const mapDispatchToProps = (dispatch) => {
  return { setDelete: (data) => dispatch(setDeleteAction(data)) };
};

export default connect(null, mapDispatchToProps)(FlightScheduleContainer);